import React, { Fragment } from 'react';

import NumberField from '../../../Base/NumberField';

class StackWeight extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            '20hold': props.stackWeight['20hold'],
            '20deck': props.stackWeight['20deck'],
            '40hold': props.stackWeight['40hold'],
            '40deck': props.stackWeight['40deck'],
            confirmed: props.confirmed,
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            '20hold': nextProps.stackWeight['20hold'],
            '20deck': nextProps.stackWeight['20deck'],
            '40hold': nextProps.stackWeight['40hold'],
            '40deck': nextProps.stackWeight['40deck'],
            confirmed: nextProps.confirmed,
        });
    }

    shouldComponentUpdate(nextProps) {
        return nextProps.stackWeight['20hold'] !== this.state['20hold']
            || nextProps.stackWeight['20deck'] !== this.state['20deck']
            || nextProps.stackWeight['40hold'] !== this.state['40hold']
            || nextProps.stackWeight['40deck'] !== this.state['40deck']
            || nextProps.getError('stackWeight.20hold').length > 0
            || nextProps.getError('stackWeight.20deck').length > 0
            || nextProps.getError('stackWeight.40hold').length > 0
            || nextProps.getError('stackWeight.40deck').length > 0
            || nextProps.confirmed !== this.state.confirmed;
    }

    render() {
        const { confirmed } = this.state;
        const { getError, changeField, modifiedFields, underStyle } = this.props;

        return (
            <Fragment>

                <div className="row">
                    <div className='col-xs-6'>
                        <NumberField
                            disabled={confirmed}
                            name='stackWeight.20hold'
                            floatingLabelText="20' Max stackweight hold"
                            value={this.state['20hold'] || ''}
                            errorText={getError('stackWeight.20hold')}
                            fullWidth
                            floatNumber
                            min={0}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'stackWeight.20hold',
                                    value,
                                    type: 'number'
                                });
                            }}

                            underlineStyle={modifiedFields && modifiedFields.includes('stackWeight.20hold') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-6'>
                        <NumberField
                            disabled={confirmed}
                            name='stackWeight.20deck'
                            floatingLabelText="20' Max stackweight deck"
                            value={this.state['20deck'] || ''}
                            errorText={getError('stackWeight.20deck')}
                            fullWidth
                            floatNumber
                            min={0}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'stackWeight.20deck',
                                    value,
                                    type: 'number'
                                });
                            }}

                            underlineStyle={modifiedFields && modifiedFields.includes('stackWeight.20deck') ? underStyle : null}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className='col-xs-6'>
                        <NumberField
                            disabled={confirmed}
                            name='stackWeight.40hold'
                            floatingLabelText="40' Max stackweight hold"
                            value={this.state['40hold'] || ''}
                            errorText={getError('stackWeight.40hold')}
                            fullWidth
                            floatNumber
                            min={0}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'stackWeight.40hold',
                                    value,
                                    type: 'number'
                                });
                            }}

                            underlineStyle={modifiedFields && modifiedFields.includes('stackWeight.40hold') ? underStyle : null}
                        />
                    </div>
                    <div className='col-xs-6'>
                        <NumberField
                            disabled={confirmed}
                            name='stackWeight.40deck'
                            floatingLabelText="40' Max stackweight deck"
                            value={this.state['40deck'] || ''}
                            errorText={getError('stackWeight.40deck')}
                            fullWidth
                            floatNumber
                            min={0}
                            onChange={(e, value) => {
                                changeField({
                                    field: 'stackWeight.40deck',
                                    value,
                                    type: 'number'
                                });
                            }}

                            underlineStyle={modifiedFields && modifiedFields.includes('stackWeight.40deck') ? underStyle : null}
                        />
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default StackWeight;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/StackWeight.jsx